// extracted by mini-css-extract-plugin
module.exports = {"resultShareList":"Share_resultShareList__3jlvB","resultShareItem":"Share_resultShareItem__1C9ZD"};